// src/components/layout/Header.jsx
// Navigation header component

import React, { useState, useEffect } from 'react';
import { APP_CONFIG } from '../../config/constants';
import Button from '../common/Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const AnimatedToggle = require('../common/AnimatedToggle').default;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleDark = () => setIsDark((s) => !s);

  return (
    <nav className="relative z-10 px-6 py-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
          <img src="/coasthive-logo.png" alt="Coasthive logo" className="w-12 h-12 object-contain rounded-2xl no-invert" />
          <span className={`text-3xl font-bold gradient-text`}>{APP_CONFIG.companyName}</span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          <a
            onClick={() => scrollToSection('features')}
            className="text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors dark:text-gray-300"
          >
            Features
          </a>
          <a
            onClick={() => scrollToSection('pricing')}
            className="text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors dark:text-gray-300"
          >
            Pricing
          </a>
          <a
            onClick={() => scrollToSection('contact')}
            className="text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors dark:text-gray-300"
          >
            Contact
          </a>
          <Button variant="secondary" size="small">Clientele 💼</Button>
          <Button variant="primary" size="small" onClick={() => scrollToSection('contact')}>Let's Talk! 🚀</Button>
            <div className="ml-3"><AnimatedToggle checked={isDark} onChange={toggleDark} /></div>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-2xl"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
      <div className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-xl rounded-2xl mx-6 mt-4 p-6 space-y-4 dark:bg-gray-900 dark:text-gray-200`}>
          <a
            onClick={() => scrollToSection('features')}
            className="block text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors py-2"
          >
            Features
          </a>
          <a
            onClick={() => scrollToSection('pricing')}
            className="block text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors py-2"
          >
            Pricing
          </a>
          <a
            onClick={() => scrollToSection('contact')}
            className="block text-gray-700 hover:text-pink-600 font-semibold cursor-pointer transition-colors py-2"
          >
            Contact
          </a>
          <Button variant="secondary" size="medium" fullWidth onClick={() => setIsMenuOpen(false)}>Clientele 💼</Button>
          <div className="flex items-center gap-3">
            <Button variant="primary" size="medium" fullWidth onClick={() => scrollToSection('contact')}>Let's Talk! 🚀</Button>
            {/* Removed mobile toggle */}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
